import React from 'react';

export const DownloadMessage = (props) => (
    <div className="download-message-container">
        <h1>{props.message}</h1>
    </div>
);


// WEBPACK FOOTER //
// ./src/Components/DownloadMessage.js